const footer = [
  {
    icon: 'github',
    title: 'GitHub',
    url: 'https://github.com/juandpr',
  },
  {
    icon: 'linkedin',
    title: 'LinkedIn',
    url: 'https://www.linkedin.com/in/juan-dalmasso-2b640549/',
  },
  {
    icon: 'medium',
    title: 'Medium',
    url: 'https://medium.com/@juandpr',
  }
];

export default footer;